import { TimePicker, TimePickerProps } from '@mui/x-date-pickers-latest';
import {
  Controller,
  type ControllerProps,
  type FieldPath,
  type FieldValues,
} from 'react-hook-form';

interface TimePickerControllerProps<
  TDate,
  // controller generics
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> extends Omit<ControllerProps<TFieldValues, TName>, 'render'>,
    Omit<Partial<TimePickerProps<TDate>>, 'defaultValue' | 'name'> {}

export const TimePickerController = <
  TDate,
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: TimePickerControllerProps<TDate, TFieldValues, TName>,
) => {
  const { name, control, defaultValue, disabled, rules, shouldUnregister, ...pickerProps } = props;
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      disabled={disabled}
      rules={rules}
      shouldUnregister={shouldUnregister}
      render={({ field, fieldState }) => (
        <TimePicker
          {...field}
          value={field.value}
          {...pickerProps}
          slotProps={{
            ...pickerProps?.slotProps,
            textField: {
              helperText: fieldState.error?.message,
              ...pickerProps.slotProps?.textField,
            },
          }}
        />
      )}
    />
  );
};
